export const sourceInfoMsg = (networkId, filterId) => {
    switch (networkId) {
        case 18:
            if (filterId == 26) return "Instagram only allows posts from the last 24 hours. If there are no recent posts in the 24-hour duration, then the top 50 posts will be aggregated. Also, all your upcoming posts will be aggregated. Posts collected via hashtags will not include any information of the user.";
            if (filterId == 23) return "We'll collect the latest public posts from this handle and keep aggregating new posts as they're published.";
            return null;
        default:
            return null;
    }
}

export const feedCreationBtnMsg = (networkId) => {
    switch (networkId) {
        case 1:
            return `You're all set up. Click next to preview and explore other options.`;
        case 2:
            return 'Nice. You are all set to go. Click on next to see preview and other options';
        case 3:
            return 'Great! Everything is set. Click "Next" to preview and explore additional features.';
        case 4:
            return `You're all ready. Click "Next" to preview and explore other available options.`;
        case 5:
            return `You're primed to proceed. Click "Next" to view the preview and explore further options.`;
        case 6:
            return `Well done! Click here to preview your feed and proceed to the next step.`;
        case 7:
            return `Ready to go! Click "Next" for a preview and more options.`;
        case 8:
            return `Everything is set. Click "Next" to see the preview and access additional options.`;
        case 10:
            return `All systems go. Click "Next" to check out the preview and other available features.`;
        case 12:
            return `You're set to jet. Click "Next" to see the preview and access additional features.`
        case 15:
            return `Good Job, Click here to see what your feed looks like and get to the next step. `
        case 18:
            return 'Nice. You are all set to go. Click on next to see preview and other options';
        case 19:
            return `You're good to proceed. Click "Next" to get a sneak peek and discover more options.`;
        case 20:
            return `You're all set! Hit "Next" for a sneak peek and explore more choices.`
        case 23:
            return `You're fully prepared. Click "Next" to preview and explore additional choices.`;
        case 28:
            return `You're prepared to proceed. Click "Next" to view the preview and explore further options.`
        case 31:
            return `You're fully prepared. Click "Next" to preview and explore additional choices.`
        case 32:
            return `You're prepared to proceed. Click "Next" to view the preview and explore further options.`

        default:
            return [];
    }
}



